import apiClient from './client'

export const userService = {
  getUsers: (params = {}) => apiClient.get('/users', { params }),

  createUser: (data) => apiClient.post('/users', data),

  getUserById: (id) => apiClient.get(`/users/${id}`),

  updateUser: (id, data) => apiClient.put(`/users/${id}`, data),

  deleteUser: (id) => apiClient.delete(`/users/${id}`),

  updateUserRole: (id, roleId) => apiClient.put(`/users/${id}/role`, { role_id: roleId }),
}

export const clientService = {
  getClients: (params = {}) => apiClient.get('/clients', { params }),

  getClientsCount: () => apiClient.get('/clients/count'),

  createClient: (data) => apiClient.post('/clients', data),

  getClientById: (id) => apiClient.get(`/clients/${id}`),

  updateClient: (id, data) => apiClient.put(`/clients/${id}`, data),

  deleteClient: (id) => apiClient.delete(`/clients/${id}`),

  archiveClient: (id) => apiClient.put(`/clients/${id}/archive`),
}

export default userService
